// extracted by mini-css-extract-plugin
export var bodyRow = "_ft-d";
export var cardColumns = "_ft-e";
export var ellipsesOverflow = "_ft-2";
export var flatBottomCorners = "_ft-3";
export var flatTopCorners = "_ft-4";
export var headerActionsDropdown = "_ft-f";
export var headerBottomRow = "_ft-c";
export var headerTopRow = "_ft-b";
export var orderDetailsWrapper = "_ft-0";
export var orderInfoContainer = "_ft-1";
export var productDetails = "_ft-9";
export var productImage = "_ft-5";
export var responsiveTable = "_ft-8";
export var shipmentContainer = "_ft-a";
export var tableBottomLeft = "_ft-6";
export var tableBottomRight = "_ft-7";